    import React from "react";
    import { motion } from "framer-motion";
    import JobCard from "./JobCard";
    import "../styles/JobSection.css";

    const JobSection = () => {
    return (
        <section className="job-section">
        <div className="search-bar">
            <input type="text" placeholder="Search for jobs, skills, or keywords..." />
            <div className="filters">
            <select><option>All Departments</option></select>
            <select><option>All Locations</option></select>
            <select><option>All Types</option></select>
            </div>
            <span className="positions-count">0 positions found</span>
        </div>
        </section>
    );
    };

    export default JobSection;
